import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className="bg-slate-900 text-white py-8">
      {/* Footer Grid */}
      <div className=" px-4  flex  flex-col gap-12 md:gap-0 md:flex-row justify-evenly   text-center lg:text-left">
        
        {/* Section 1: Company Info */}
        <div className="space-y-2">
          <h2 className="text-4xl font-semibold">1UKLogistics</h2>
          <p><span className="font-semibold"></span>17 Harbour House, Cold Harbour Lane,<br/> Rainham RM13 9YA, United Kingdom</p>
          <p><span className="font-semibold">Email:</span> info@1uklogistics.com</p>
          <p><span className="font-semibold">Phone:</span> +44 208 051 5530</p>
        </div>

<div className="  flex justify-center items-center">
<img src="images/rhaimg.png" className=" w-40 h-40" alt="rhaimg" />
</div>

        {/* Section 2: Quick Links */} 
        <div className="space-y-2">
  <h3 className="text-lg font-semibold">Quick Links</h3>
  <Link to="/aboutus" className="block hover:text-gray-300 cursor-pointer">About Us</Link>
  {/* <Link to="/services" className="block hover:text-gray-300 cursor-pointer">Our Services</Link> */}
  <Link to="/fleet" className="block hover:text-gray-300 cursor-pointer">The Fleet</Link>
  <Link to="/airfreightservice" className="block hover:text-gray-300 cursor-pointer">Air Freight</Link>
  <Link to="/shipping" className="block hover:text-gray-300 cursor-pointer">Shipping Services</Link>
  <Link to="/europeanservices" className="block hover:text-gray-300 cursor-pointer">European Transport</Link>
</div>

        {/* Section 3: Legal */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">Legal</h3>
          <p className="hover:text-gray-300 cursor-pointer">Privacy Policy</p>
          <p className="hover:text-gray-300 cursor-pointer">Terms & Conditions</p>
          <p className="hover:text-gray-300 cursor-pointer">FAQ</p>
  <Link to="/contactus" className="block hover:text-gray-300 cursor-pointer">Contact</Link>

        </div>



        {/* Section 4: Social Media */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">Follow Us</h3>
          <div className="flex justify-center lg:justify-start gap-4">
            <a href="https://www.facebook.com/1uklogistics?mibextid=wwXIfr&rdid=mM07a0DFX25Nctdq&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19v58fdBMo%2F%3Fmibextid%3DwwXIfr#">
              <img src="images/facebook.png" className="w-6 h-6 md:w-8 md:h-8" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/1uklogistics/?igsh=MXhkNHlweHpjM2MwaA%3D%3D#" target="_blank" rel="noopener noreferrer">
              <img src="images/insta.png" className="w-6 h-6 md:w-8 md:h-8" alt="Instagram" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src="images/twitter.png" className="w-6 h-6 md:w-8 md:h-8" alt="Twitter" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <img src="images/linkedin.png" className="w-6 h-6 md:w-8 md:h-8" alt="LinkedIn" />
            </a>
          </div>
          {/* news letter */}
          <div className="flex items-center justify-center pt-6">
      <div className="relative w-full max-w-md">
        <input
          type="email"
          placeholder="Enter your email"
          className="px-4 w-72 xl:w-96 py-3 pr-16 text-gray-700 bg-white border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button className="absolute top-1/2 right-2 -translate-y-1/2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition">
          Subscribe
        </button>
      </div>
    </div>
        </div>
        
      </div>

      {/* Divider */}
      <div className="my-6 border-t border-zinc-500" />

      {/* Bottom Footer */}
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between text-xs text-center md:text-left">
        <p>All business subject to BIFA standard trading terms and conditions</p>
        <p>Powered by Alif Dynamics Inc. Canada.</p>
      </div>
    </div>
  );
}

export default Footer;



// import React from 'react'

// function Footer() {
//   return (
//     <div className= ' flex  flex-col bg-slate-900 text-white mt-20'>
      
//       <div className='flex justify-around  items-center  p-14'>

//       {/* div1 */}
//       <div >
//       <h2 className="text-3xl md:text-4xl  font-narnoor lg:text-5xl font-ciz text-left  mb-2">
//       1UKLogistics </h2>

//               {/* Social Media Links Section */}
//           <h3 className="text-lg md:text-xl  text-left font-semibold mt-4 mb-2">Follow Us</h3>
//           <div className="flex gap-4">
//             <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//               <img src="images/facebook.png" className="w-6 h-6 lg:w-8 lg:h-8" alt="Facebook" />
//             </a>
//             <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
//               <img src="images/insta.png" className="w-6 h-6 lg:w-8 lg:h-8" alt="Instagram" />
//             </a>
//             <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
//               <img src="images/twitter.png" className="w-6 h-6 lg:w-8 lg:h-8" alt="Twitter" />
//             </a>
//             <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
//               <img src="images/linkedin.png" className="w-6 h-6 lg:w-8 lg:h-8" alt="LinkedIn" />
//             </a>
//           </div>
//       </div>

//       {/* div 2 */}
//       <div className='flex flex-col gap-1 text-white'>
//         <h1 className=' text-xl underline font-semibold pb-4'>Consolidation</h1>
//         <p>Weekly & Fortnightly LCL</p>
//         <p>Worldwide FCL</p>
//         <p>Import LCL & FCL</p>
//         <p>Sailing Schedules</p>

//       </div>

//  {/* div 3 */}
//  <div className='flex flex-col gap-1 text-white'>
//         <h1 className=' text-xl underline font-semibold pb-4'>Air Freight</h1>
//         <p>To London</p>
//         <p>To Australia</p>
//         <p>To Hong Kong</p>
//         <p>To Singapore</p>

//       </div>

//        {/* div 4 */}
//  <div className='flex flex-col gap-1 text-white'>
//         <h1 className=' text-xl underline font-semibold pb-4'>Sea Freight</h1>
//         <p> To Dubai </p>
//         <p>To Canada</p>
//         <p>To USA </p>
//         <p>To China</p>
//       </div>

//        {/* div 5 */}
//       <div className='flex flex-col gap-1 text-white'>
//         <h1 className=' text-xl underline font-semibold pb-4'>Road Freight</h1>
//         <p> To Belgium </p>
//         <p>To Spain</p>
//         <p>To France </p>
//         <p>To Ireland</p>
//       </div>

//       </div>
      

//         {/* Line Separator */}
//         <div className="my-4 border-t border-zinc-500" />
//       <div className='flex justify-around mb-4'>
//       <div className="flex gap-4 md:gap-0 xl:gap-10 ">
//             <a href="#" className="hover:text-gray-300 text-sm md:text-base">
//              Privacy Policy  
//             </a>
//             <a href="#" className="hover:text-gray-300 text-sm md:text-base">
//             Terms & Conditions
//             </a>
//           </div>

//           <div className="text-center text-sm md:text-base">
//       All business subject to BIFA standard trading terms and conditions
//       </div>

//  {/* Footer Bottom Text */}
//  <div className="text-center text-sm md:text-base">
//         Powered by Alif Dynamics Inc. Canada.
//       </div>

     
//       </div>
//     </div>
//   )
// }

// export default Footer

